import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import { CRUSH_PROFILE_TYPE } from 'type-defs'
import MatchItem from 'components/matches/MatchItem'

const Matches = ({ matches, onSendMessage, onMatchClick, onDeleteMatch }) => {
  return (
    <Div flex={1} overflowY="auto">
      {matches.map((crush, i) => (
        <Div
          key={crush.id}
          paddingTop={15}
          paddingBottom={15}
          display="flex"
          alignItems="center"
          borderBottom="1px solid #dbdce0"
        >
          <MatchItem
            {...crush}
            onSendMessage={onSendMessage(crush)}
            onMatchClick={onMatchClick(crush)}
            onDeleteMatch={onDeleteMatch(crush)}
          />
        </Div>
      ))}
    </Div>
  )
}

Matches.propTypes = {
  matches: PropTypes.arrayOf(PropTypes.shape(CRUSH_PROFILE_TYPE)),
  onSendMessage: PropTypes.func,
  onMatchClick: PropTypes.func,
  onDeleteMatch: PropTypes.func
}

Matches.defaultProps = {
  onSendMessage: () => {},
  onMatchClick: () => {},
  onDeleteMatch: () => {}
}

export default Matches



// WEBPACK FOOTER //
// ./src/components/matches/Matches.js